import React from "react";
import SectionTitle from "../common/section_title";

import Grid from "@mui/material/Grid";
import styles from "./counsellor_list.module.scss";
import CounsellerCard from "@modules/admin/student/shared/counseller_card";

export const CounsellorList = ({ counsellor }) => {
  return (
    <section className={styles.section_counsellor_list}>
      <div className="container">
        <SectionTitle
          shadow_text="Our Counsellors"
          title="Counsellors"
        ></SectionTitle>

        <Grid container spacing={2}>
          {counsellor.map((item) => (
            <Grid item xs={12} md={4} lg={3} key={item.id}>
              <CounsellerCard
                border
                iconVerified={item.iconVerified}
                avatar={item.profilePic}
                name={`${item.firstName} ${item.lastName} `}
                country={item.country.name}
                university={item.university}
                designation={item.designation}
                link={item.link}
              />
            </Grid>
          ))}
        </Grid>
      </div>
    </section>
  );
};

export default CounsellorList;
